import { Component } from '@angular/core';

/** Public landing page after an explicit Okta end-session redirect. */
@Component({
  selector: 'app-signed-out',
  standalone: true,
  template: `<main style="max-width:36rem;margin:12vh auto;padding:2rem;font-family:Arial,sans-serif">
    <h1>Signed out</h1>
    <p>You have signed out of Hub Central.</p>
    <a href="/">Sign in again</a>
  </main>`,
})
export class SignedOutPage {}
